/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import Select from "react-select";
import "./EMPDailyStatus.css";
import axios from "axios";
import { Apiurl } from "../../../Utils/utils";
import { toast } from "react-toastify";
import EMPMonthlyReport from "./Empmonthlyreport";

const EMPDailyStatus = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeTab, setActiveTab] = useState("dsr");
  const [editingId, setEditingId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    date: "",
    project: null,
    hours: "",
    minutes: "",
    task: "",
  });

  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    project: null,
  });

  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);

  const getToken = () =>
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const parseApiData = (data) => {
    if (!data) return [];

    let parsedData = data;

    if (typeof parsedData === "string") {
      parsedData = JSON.parse(parsedData);
    }

    if (parsedData?.Data) parsedData = parsedData.Data;
    if (parsedData?.data) parsedData = parsedData.data;

    return Array.isArray(parsedData) ? parsedData : [];
  };

  const RetrieveProjects = () => {
    const LoginToken = getToken();

    axios({
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Projects/GetProjectsByUserId`,
    })
      .then((response) => {
        const apiData = response?.data?.Data || response?.data?.data;
        const projectsArray = parseApiData(apiData);

        const modifiedData = projectsArray.map((item) => ({
          value: item.ProjectId || item.projectId,
          label: item.ProjectName || item.projectName,
          projectType: item.ProjectType || item.projectType,
        }));

        setProjects(modifiedData);
      })
      .catch((error) => {
        console.log("Project API Error:", error);
        toast.error("Failed to load projects");
      });
  };

  const formatToBackendTime = (value, type) => {
    if (value === "" || value === null || value === undefined) {
      return null;
    }

    const num = Number(value);

    if (type === "hour") {
      return `${String(num).padStart(2, "0")}:00:00`;
    }

    if (type === "minute") {
      return `00:${String(num).padStart(2, "0")}:00`;
    }

    return null;
  };

  const formatFromBackendTime = (hourStr, minuteStr) => {
    const h = Number(hourStr?.split(":")[0] || 0);
    const m = Number(minuteStr?.split(":")[1] || 0);

    return `${h} hr ${m} min`;
  };

  const handleEditTask = (item) => {
    setFormData({
      date: item.Date?.split("T")[0] || "",
      project: {
        value: item.ProjectId,
        label: item.Project?.ProjectName || item.ProjectName,
      },
      hours: item.Hours?.split(":")[0] || "",
      minutes: item.Minutes?.split(":")[1] || "",
      task: item.TaskDetail || "",
    });

    setEditingId(item.Id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancelEdit = () => {
    setFormData({
      date: "",
      project: null,
      hours: "",
      minutes: "",
      task: "",
    });

    setEditingId(null);
  };

  const handleSaveTask = () => {
    if (
      !formData.date ||
      !formData.project ||
      !formData.task ||
      formData.hours === "" ||
      formData.minutes === ""
    ) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);

    const LoginToken = getToken();

    const formattedHours = formatToBackendTime(formData.hours, "hour");
    const formattedMinutes = formatToBackendTime(formData.minutes, "minute");

    const safeTaskDetail = formData.task.replace(/'/g, '"');

    const payloadObject = editingId
      ? {
          Id: editingId,
          Date: formData.date,
          ProjectId: formData.project.value,
          Hours: formattedHours,
          Minutes: formattedMinutes,
          TaskDetail: safeTaskDetail,
        }
      : {
          Date: formData.date,
          ProjectId: formData.project.value,
          Hours: formattedHours,
          Minutes: formattedMinutes,
          TaskDetail: safeTaskDetail,
        };

    axios({
      method: "POST",
      headers: {
        authorization: `Bearer ${LoginToken}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Task/SaveTaskDetail`,
      data: {
        data: JSON.stringify(payloadObject),
      },
    })
      .then(() => {
        toast.success(
          editingId ? "Task updated successfully" : "Task saved successfully"
        );

        setFormData({
          date: "",
          project: null,
          hours: "",
          minutes: "",
          task: "",
        });

        setEditingId(null);
        GetTasks();
      })
      .catch((error) => {
        console.log("Save Task Error:", error);
        toast.error(editingId ? "Failed to update task" : "Failed to save task");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const GetTasks = (overrideFilters = null) => {
    const LoginToken = getToken();
    const filters = overrideFilters || filterData;

    const payloadObject = {
      fromDate: filters.fromDate || "",
      toDate: filters.toDate || "",
      dayscount: "",
    };

    axios({
      method: "POST",
      headers: {
        authorization: `Bearer ${LoginToken}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Task/GetTasks`,
      data: {
        data: JSON.stringify(payloadObject),
      },
    })
      .then((res) => {
        const parsed = JSON.parse(res?.data?.data || "[]");

        let filtered = parsed;

        if (filters.project) {
          filtered = filtered.filter(
            (t) => Number(t.ProjectId) === Number(filters.project.value)
          );
        }

        setTasks(filtered);
      })
      .catch((error) => {
        console.log("Get Tasks Error:", error);
        setTasks([]);
      });
  };

  const handleDeleteTask = (id) => {
    const LoginToken = getToken();

    const payloadObject = {
      Id: id,
    };

    axios({
      method: "POST",
      headers: {
        authorization: `Bearer ${LoginToken}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Task/DeleteTask`,
      data: {
        data: JSON.stringify(payloadObject),
      },
    })
      .then(() => {
        toast.success("Task deleted successfully");
        setTasks((prev) => prev.filter((item) => item.Id !== id));
        setShowDeleteModal(false);
        setDeleteId(null);
        GetTasks();
      })
      .catch(() => {
        toast.error("Failed to delete task");
        setShowDeleteModal(false);
      });
  };

  const handleResetFilters = () => {
    const cleared = {
      fromDate: "",
      toDate: "",
      project: null,
    };

    setFilterData(cleared);
    GetTasks(cleared);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Reset DSR form state when switching away
    if (tab !== "dsr") {
      setEditingId(null);
      setFormData({ date: "", project: null, hours: "", minutes: "", task: "" });
    }
  };

  useEffect(() => {
    RetrieveProjects();
    GetTasks();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) {
      setShowSidebar(false);
    }
  }, []);

  const isFormValid =
    formData.date &&
    formData.project &&
    formData.task &&
    formData.hours !== "" &&
    formData.minutes !== "";

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <section
          className={
            showSidebar
              ? "EMP-timesheet-section"
              : "EMP-timesheet-section-full"
          }
        >
          <div className="EMP-timesheet-header">
            <h2>Daily Status Report</h2>

            <div className="timesheet-breadcrumb">
              <BiHomeAlt />
              <MdKeyboardArrowRight />
              <span>Daily Status Report</span>
              <MdKeyboardArrowRight />
              <span>{activeTab === "dsr" ? "Add Entry" : "Monthly Report"}</span>
            </div>
          </div>

          {/* Tabs */}
          <div className="tabs-section-AdminDSR" style={{ marginBottom: "16px" }}>
            <button
              className={`tab-button ${activeTab === "dsr" ? "active" : ""}`}
              onClick={() => handleTabChange("dsr")}
            >
              Daily Status Report
            </button>
            <button
              className={`tab-button ${activeTab === "report" ? "active" : ""}`}
              onClick={() => handleTabChange("report")}
            >
              Monthly Report
            </button>
          </div>

          {/* Tab: DSR Entry */}
          {activeTab === "dsr" && (
            <div className="timesheet-card">
              <div className="timesheet-note">
                <span>* Please fill all the fields before saving the task.</span>
              </div>

              <div className="timesheet-form-grid">
                <div className="form-group">
                  <label>Date</label>
                  <input
                    type="date"
                    value={formData.date}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setFormData({ ...formData, date: e.target.value })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>Project</label>
                  <Select
                    options={projects}
                    value={formData.project}
                    onChange={(val) =>
                      setFormData({ ...formData, project: val })
                    }
                    placeholder="Select Project"
                    isClearable
                  />
                </div>

                <div className="form-group">
                  <label>Hours</label>
                  <input
                    type="number"
                    placeholder="0"
                    min="0"
                    max="10"
                    value={formData.hours}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (Number(value) > 10) {
                        toast.warning("Maximum allowed hours is 10");
                        value = 10;
                      }
                      setFormData({ ...formData, hours: value });
                    }}
                  />
                  <small className="input-hint">*Max 10 hours</small>
                </div>

                <div className="form-group">
                  <label>Minutes</label>
                  <input
                    type="number"
                    placeholder="00"
                    min="0"
                    max="59"
                    value={formData.minutes}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (Number(value) > 59) {
                        toast.warning("Maximum allowed minutes is 59");
                        value = 59;
                      }
                      setFormData({ ...formData, minutes: value });
                    }}
                  />
                  <small className="input-hint">*Max 59 minutes</small>
                </div>

                <div className="form-group full">
                  <label>Task Detail</label>
                  <textarea
                    rows="4"
                    value={formData.task}
                    onChange={(e) =>
                      setFormData({ ...formData, task: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="timesheet-action-btns">
                <button
                  className="timesheet-save-btn"
                  onClick={handleSaveTask}
                  disabled={loading || !isFormValid}
                >
                  {loading ? "Saving..." : editingId ? "UPDATE" : "SAVE"}
                </button>

                {editingId && (
                  <button
                    className="timesheet-cancel-btn"
                    onClick={handleCancelEdit}
                  >
                    CANCEL
                  </button>
                )}
              </div>

              <div className="timesheet-filters">
                <div className="filter-group">
                  <label>From Date</label>
                  <input
                    type="date"
                    value={filterData.fromDate}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setFilterData({ ...filterData, fromDate: e.target.value })
                    }
                  />
                </div>

                <div className="filter-group">
                  <label>To Date</label>
                  <input
                    type="date"
                    value={filterData.toDate}
                    max={new Date().toISOString().split("T")[0]}
                    min={filterData.fromDate || ""}
                    onChange={(e) =>
                      setFilterData({ ...filterData, toDate: e.target.value })
                    }
                  />
                </div>

                <div className="filter-group">
                  <label>Select Project</label>
                  <Select
                    options={projects}
                    value={filterData.project}
                    onChange={(val) =>
                      setFilterData({ ...filterData, project: val })
                    }
                    placeholder="Select Project"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>

                <button className="search-btn" onClick={() => GetTasks()}>
                  Search
                </button>

                <button className="reset-btn" onClick={handleResetFilters}>
                  Reset
                </button>
              </div>

              <div className="timesheet-table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Project Name</th>
                      <th>Task</th>
                      <th>Hour</th>
                      <th>Edit / Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    {tasks.length ? (
                      tasks.map((item, index) => (
                        <tr key={item.Id || index}>
                          <td>{index + 1}</td>
                          <td>{item.Date?.split("T")[0]}</td>
                          <td>
                            {item.Project?.ProjectName ||
                              item.ProjectName ||
                              "N/A"}
                          </td>
                          <td>{item.TaskDetail}</td>
                          <td>
                            {formatFromBackendTime(item.Hours, item.Minutes)}
                          </td>
                          <td>
                            <button
                              className="edit-btn"
                              onClick={() => handleEditTask(item)}
                            >
                              Edit
                            </button>

                            <button
                              className="delete-btn"
                              onClick={() => {
                                setDeleteId(item.Id);
                                setShowDeleteModal(true);
                              }}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6">No data found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Tab: Monthly Report */}
          {activeTab === "report" && <EMPMonthlyReport />}

          {/* Delete Confirmation Modal */}
          {showDeleteModal && (
            <div className="delete-modal-overlay">
              <div className="delete-modal">
                <h3>Confirm Delete</h3>
                <p>Are you sure you want to delete this task?</p>

                <div className="delete-modal-actions">
                  <button
                    className="confirm-delete-btn"
                    onClick={() => handleDeleteTask(deleteId)}
                  >
                    Yes
                  </button>

                  <button
                    className="cancel-delete-btn"
                    onClick={() => {
                      setShowDeleteModal(false);
                      setDeleteId(null);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default EMPDailyStatus;